export default {
    backendUrl: "https://hermes.mhr.re"
    backendMediaUrl: "https://hermes.mhr.re/media/"
    authApiUrl: "https://hermes.mhr.re/auth/login/"
    authApiUrlLogout: "https://hermes.mhr.re/auth/logout/"
    graphqlApiUrl: "https://hermes.mhr.re/graphql/"
    websocketUrl: "wss://hermes.mhr.re/ws/models/"
    etherpadUrl: 'https://hermes.mhr.re/pad/p/'
    review_export_data_url: 'https://hermes.mhr.re/admin/review/export/'
}
